/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Status_In_DeliveryInputs */

const vi_cdo_status_in_delivery = /** @type {(inputs: Cdo_Status_In_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang giao`)
};

/**

* @param {Cdo_Status_In_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_status_in_delivery = /** @type {((inputs?: Cdo_Status_In_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Status_In_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_status_in_delivery(inputs)
});